import * as React from 'react';
import PropTypes from 'prop-types';

import RCAppBar from './RCAppBar';
import RCAppSideBar from './RCAppSideBar';
import RCAppSideBarAndContent from './RCAppSideBarAndContent';
import RCAppContent from './RCAppContent';

class RCMain extends React.Component {

    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {

        apiTasks                             : PropTypes.array.isRequired,
        onAddTasks                           : PropTypes.func.isRequired,

        appState                             : PropTypes.any.isRequired,
        onStateChange                        : PropTypes.func.isRequired,

        getDataVisChart                      : PropTypes.func.isRequired,
        onDrawerChange                       : PropTypes.func.isRequired,
        onLanguageChange                     : PropTypes.func.isRequired,
        onSideBarArrowClick                  : PropTypes.func.isRequired,
        heartBeat                            : PropTypes.number.isRequired,
        onPackTableChange                    : PropTypes.func.isRequired,
        onPageChange                         : PropTypes.func.isRequired,
        onProjectionAdd                      : PropTypes.func.isRequired,
        onQ1Answered                         : PropTypes.func.isRequired,
        onQ2Answered                         : PropTypes.func.isRequired,

        onTargPopParamValueChange            : PropTypes.func.isRequired,
        onTargPopCustomStrChange             : PropTypes.func.isRequired,
        onSelectedIndicatorChange            : PropTypes.func.isRequired,
        onAnalyzeIndicatorChange             : PropTypes.func.isRequired,
        onIndicatorNameChange                : PropTypes.func.isRequired,
        onGroupNameChange                    : PropTypes.func.isRequired,
        onGroupPanelExpandedChange           : PropTypes.func.isRequired,
        onAddGroup                           : PropTypes.func.isRequired,
        onDeleteGroup                        : PropTypes.func.isRequired,
        onMoveGroup                          : PropTypes.func.isRequired,
        onIndicatorDataChange                : PropTypes.func.isRequired,
        onIndicatorGroupChange               : PropTypes.func.isRequired,
        onIndicatorObjListChange             : PropTypes.func.isRequired,
        onIndicatorParamLabChange            : PropTypes.func.isRequired,
        onIndicatorTargPopCurrIDChange       : PropTypes.func.isRequired,
        onIndicatorTargPopTypeChange         : PropTypes.func.isRequired,

    };

    static defaultProps = {

        apiTasks                             : [],
        onAddTasks                           : () => {},

        state                                : null,
        onStateChange                        : () => {},

        getDataVisChart                      : () => console.log("getDataVisChart"),
        onDrawerChange                       : () => {},
        onLanguageChange                     : () => console.log("onLanguageChange"),
        onSideBarArrowClick                  : () => console.log("onSideBarArrowClick"),
        heartBeat                            : -1,
        onPackTableChange                    : () => {},
        onPageChange                         : () => {},
        onProjectionAdd                      : () => {},

        onQ1Answered                         : () => console.log("onQ1Answered"),
        onQ2Answered                         : () => console.log("onQ2Answered"),

        onTargPopParamValueChange            : () => console.log("onTargPopParamValueChange"),
        onTargPopCustomStrChange             : () => console.log("onTargPopCustomStrChange"),
        onSelectedIndicatorChange            : () => console.log("onSelectedIndicatorChange"),
        onAnalyzeIndicatorChange             : () => console.log("onAnalyzeIndicatorChange"),
        onIndicatorNameChange                : () => console.log("onIndicatorNameChange"),
        onGroupNameChange                    : () => console.log("onGroupNameChange"),
        onAddGroup                           : () => console.log("onAddGroup"),
        onDeleteGroup                        : () => console.log("onDeleteGroup"),
        onMoveGroup                          : () => console.log("onMoveGroup"),
        onIndicatorDataChange                : () => console.log("onIndicatorDataChange"),
        onIndicatorGroupChange               : () => console.log("onIndicatorGroupChange"),
        onIndicatorObjListChange             : () => console.log("onIndicatorObjListChange"),
        onIndicatorParamLabChange            : () => console.log("onIndicatorParamLabChange"),
        onIndicatorTargPopCurrIDChange       : () => console.log("onIndicatorTargPopCurrIDChange"),
        onIndicatorTargPopTypeChange         : () => console.log("onIndicatorTargPopTypeChange"),
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {

        /* Props */
        const props = this.props;

        const appState = props.appState;
        const sideBarOpen = appState.sideBarOpen;

        let appSideBarArrowBtnWidth = 0;//40;
        let appSideBarWidthClosed = appSideBarArrowBtnWidth;
        let appSideBarWidthOpen = 310 + appSideBarArrowBtnWidth;

        let appSideBarWidth = 0;

        if (sideBarOpen) {

            appSideBarWidth = appSideBarWidthOpen;

        }
        else {

            appSideBarWidth = appSideBarWidthClosed;

        }

        const layout = {

            appBar : {

                height : 65,

            },

            appSideBar : {

                width : appSideBarWidth,

            },

            appBarTitleStyle : {
                cursor      : "pointer",
                fontSize    : 35,
                marginLeft  : 15, // makes put space between the word from the logo and the app title
                marginTop   : 10, // makes the rest of the app title line up with the logo...not the best solution
                width       : 700,
                whiteSpace  : "nowrap",
            }

        };

        const appBar =
            <RCAppBar
                onAddTasks                      = {props.onAddTasks}

                onDrawerChange                  = {props.onDrawerChange}

                language                        = {props.appState.language}
                onLanguageChange                = {props.onLanguageChange}

                pageID                          = {props.appState.pageID}
                onPageChange                    = {props.onPageChange}

                onSideBarArrowClick             = {props.onSideBarArrowClick}

                titleStyle                      = {layout.appBarTitleStyle}
            />;

        const appSideBar =
            <RCAppSideBar
                appState            = {props.appState}

                pageID              = {props.appState.pageID}
                onPageChange        = {props.onPageChange}

                sideBarOpen         = {props.appState.sideBarOpen}
                onSideBarArrowClick = {props.onSideBarArrowClick}

                sideBarWidthClosed  = {appSideBarArrowBtnWidth}
                sideBarWidthOpen    = {appSideBarWidthOpen}
            />;

        const appContent =
            <RCAppContent
                onAddTasks                    = {props.onAddTasks}

                appBarHeight                  = {layout.appBar.height}
                appSideBarWidth               = {appSideBarWidth}

                appState                      = {props.appState}
                onStateChange                 = {props.onStateChange}

                getDataVisMap                 = {props.getDataVisMap}
                onDataVisualizationObjChange  = {props.onDataVisualizationObjChange}
                onDrawerChange                = {props.onDrawerChange}

                left                          = {layout.appSideBar.width}

                onPackTableChange             = {props.onPackTableChange}
                onPageChange                  = {props.onPageChange}

                onQ1Answered                  = {props.onQ1Answered}
                onQ2Answered                  = {props.onQ2Answered}

                onSideBarArrowClick           = {props.onSideBarArrowClick}

                onTargPopParamValueChange     = {props.onTargPopParamValueChange}
                onTargPopCustomStrChange      = {props.onTargPopCustomStrChange}
                onSelectedIndicatorChange     = {props.onSelectedIndicatorChange}
                onAnalyzeIndicatorChange      = {props.onAnalyzeIndicatorChange}
                onIndicatorNameChange         = {props.onIndicatorNameChange}
                onGroupNameChange             = {props.onGroupNameChange}
                onGroupPanelExpandedChange    = {props.onGroupPanelExpandedChange}
                onAddGroup                    = {props.onAddGroup}
                onDeleteGroup                 = {props.onDeleteGroup}
                onMoveGroup                   = {props.onMoveGroup}
                onIndicatorDataChange         = {props.onIndicatorDataChange}
                onIndicatorGroupChange        = {props.onIndicatorGroupChange}
                onIndicatorObjListChange      = {props.onIndicatorObjListChange}
                onIndicatorParamLabChange     = {props.onIndicatorParamLabChange}
                onIndicatorTargPopCurrIDChange = {props.onIndicatorTargPopCurrIDChange}
                onIndicatorTargPopTypeChange  = {props.onIndicatorTargPopTypeChange}
            />;

        return (
            <div>

                {appBar}

                <RCAppSideBarAndContent
                    top = {layout.appBar.height}
                >

                    {appSideBar}
                    {appContent}

                </RCAppSideBarAndContent>

            </div>
        );
    }
}

export default RCMain;